import { CheckmobiCheckPinRequest } from 'types/api/CheckmobiCheckPinRequest'
import { CheckmobiValidationRequest } from 'types/api/CheckmobiValidationRequest'
import { triggerPhoneVerification, verifyPhone } from './auth'
import { CheckmobiValidationResponse } from 'types/api/CheckmobiValidationResponse'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export function requestSMSFromCheckmobi(data: CheckmobiValidationRequest) {
  return triggerPhoneVerification(data).then((response) => {
    const data: CheckmobiValidationResponse = response.data
    LocalStorage.remove(LocalStorageKey.FIREBASE_TOKEN)
    LocalStorage.set(LocalStorageKey.CHECKMOBI_TOKEN, data.id)
    return data
  })
}

export function validatePin(data: CheckmobiCheckPinRequest) {
  return verifyPhone('web', data.pin, data.id).then((response) => {
    const data = response.data
    return { validated: data.validated, number: data.number }
  })
}
